/* Generated companion for hide-imported-review-photos.css.
   Hides gallery / lightbox images matched by filename when they are not
   nested under [data-review-id]. Future photos with new URLs are left alone. */
(function () {
  var FILES = window.AL_IMPORTED_REVIEW_PHOTO_FILES;
  if (!FILES || !FILES.length) return;
  var set = {};
  for (var i = 0; i < FILES.length; i++) set[FILES[i]] = 1;

  function token(url) {
    if (!url) return "";
    try {
      url = decodeURIComponent(String(url).split("?")[0]);
    } catch (e) {}
    var parts = url.split("/");
    return parts[parts.length - 1];
  }

  function listed(el) {
    var attrs = ["src", "data-src", "href", "data-mfp-src", "data-src-retina"];
    for (var i = 0; i < attrs.length; i++) {
      var t = token(el.getAttribute(attrs[i]));
      if (t && set[t]) return true;
    }
    var srcset = el.getAttribute("srcset") || el.getAttribute("data-srcset") || "";
    if (srcset) {
      var bits = srcset.split(",");
      for (var j = 0; j < bits.length; j++) {
        var t2 = token(bits[j].trim().split(" ")[0]);
        if (t2 && set[t2]) return true;
      }
    }
    return false;
  }

  function hideNode(el) {
    var box =
      el.closest(
        ".jdgm-rev__pics, .jdgm-rev__pic-link, .jdgm-popup-card__pic-wrapper, .jdgm-full-rev__pics, .jdgm-gallery-item, .jdgm-picture-gallery__item, .jdgm-rev-widg__media-item, .jdgm-media-item, .jdgm-all-reviews__photo, .jdgm-carousel-item__review-picture"
      ) || el;
    box.style.setProperty("display", "none", "important");
    box.setAttribute("hidden", "");
  }

  function genuineReviewPhoto() {
    var nodes = document.querySelectorAll(
      'img[src*="review-images.judgeme.com"], img[data-src*="review-images.judgeme.com"], a[href*="review-images.judgeme.com"]'
    );
    for (var i = 0; i < nodes.length; i++) {
      if (!listed(nodes[i])) return true;
    }
    return false;
  }

  function stripPictureSorts(root) {
    if (genuineReviewPhoto()) return;
    var scope = root && root.querySelectorAll ? root : document;
    var opts = scope.querySelectorAll
      ? scope.querySelectorAll(
          '#jm-sort-filter option[value="only_pictures"], #jm-sort-filter option[value="pictures_first"], select.jdgm-sort-dropdown option[value="only_pictures"], select.jdgm-sort-dropdown option[value="pictures_first"]'
        )
      : [];
    for (var i = 0; i < opts.length; i++) {
      if (opts[i].parentNode) opts[i].parentNode.removeChild(opts[i]);
    }
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll
      ? scope.querySelectorAll(
          'a[href*="review-images.judgeme.com"], a[data-mfp-src*="review-images.judgeme.com"], img[src*="review-images.judgeme.com"], img[data-src*="review-images.judgeme.com"], source[srcset*="review-images.judgeme.com"]'
        )
      : [];
    for (var i = 0; i < nodes.length; i++) {
      if (listed(nodes[i])) hideNode(nodes[i]);
    }
    stripPictureSorts(root);
  }

  function start() {
    scan(document);
    if (!window.MutationObserver) return;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.type === "childList") {
          for (var j = 0; j < m.addedNodes.length; j++) scan(m.addedNodes[j]);
        } else if (m.type === "attributes") {
          scan(m.target);
        }
      }
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["src", "data-src", "href", "data-mfp-src", "srcset"],
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
